import useAuth from "./useAuth";
import { useQuery } from "@tanstack/react-query";
import { AccountType } from "../contexts/JWTContext";
import clientApi from "../api/clientApi";
import notaryApi from "../api/notaryApi";

export default function useUserQuery() {
  const { accountType, userId } = useAuth();
  const api = accountType === AccountType.client ? clientApi : notaryApi;
  return useQuery(["user", userId], () => api.loadProfile() as Promise<APIResponse<Client | Notary>>, {
    enabled: !!userId,
    refetchInterval: 60000,
    select: (data) => data?.data
  });
}